import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/apiClient";
import { useCart } from "@/contexts/CartContext";
import { CheckCircle } from "@phosphor-icons/react";

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState(null);
  const [attempts, setAttempts] = useState(0);
  const { clear } = useCart();

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;

    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        setStatus(data);
        if (data.payment_status === "paid") {
          clear();
          return;
        }
        if (data.payment_status === "failed" || data.payment_status === "expired") return;
        if (attempts < 15) {
          setAttempts((a) => a + 1);
          setTimeout(poll, 2000);
        }
      } catch { /* keep polling */ }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="payment-success-page">
      {status?.payment_status === "paid" ? (
        <>
          <CheckCircle size={80} weight="duotone" className="text-green-600 mx-auto mb-6" />
          <h1 className="font-display font-black text-5xl tracking-tighter mb-4">Payment Confirmed</h1>
          <p className="text-neutral-600 mb-2">Thank you! Your order <strong>#{status.order_number}</strong> is now paid.</p>
          <p className="text-neutral-500 text-sm mb-8">Amount: €{status.amount?.toFixed(2)} · Confirmation sent to your email.</p>
          <div className="flex gap-3 justify-center">
            <Link to="/account" className="vt-btn-orange">View Order</Link>
            <Link to="/shop" className="vt-btn-outline">Continue Shopping</Link>
          </div>
        </>
      ) : (
        <>
          <div className="animate-pulse w-20 h-20 rounded-full border-4 border-[color:var(--vt-orange)] border-t-transparent mx-auto mb-6"></div>
          <h1 className="font-display font-black text-4xl tracking-tighter mb-4">Confirming Payment…</h1>
          <p className="text-neutral-500 text-sm">Please don't close this page.</p>
        </>
      )}
    </div>
  );
}
